import getMosaicStyles from "@ext/markdown/elements/gallery/logic/getMosaicStyles";
import type { GalleryViewProps } from "@ext/markdown/elements/gallery/render/views/types";

const MosaicView = ({ scope, items, children }: GalleryViewProps) => (
	<>
		<style>
			{getMosaicStyles(
				scope,
				items.map((item) => item.ratio),
			)}
		</style>
		{children}
	</>
);

export default MosaicView;
